/**
 * This is table-header script.js file
 */

/* eslint-disable max-len */
import { setTableWidths } from '@/use/table.space';

export default {
  name: 'VTableHeader',
  /**
   * @override
   */
  data() {
    return {
      cols: [],
      lastDragXPosition: null,
      widthsData: {},
      selectAllItems: false,
      orderByFields: [],
      notSortableFields: [
        'interveners',
        'photo',
        'operations',
        'accounts',
        'has_draft_data',
        'has_docs_pending_validation'
      ],
      localStorageWidthsData: null
    };
  },
  props: {
    widths: {
      type: Object,
      required: true
    },
    columns: {
      type: Array,
      required: true
    }
  },
  /**
   * Al crear el componente calculamos los anchos de cada columna
   */
  created() {
    this.widthsData = setTableWidths(this.$route.name, this.columns);
  },
  methods: {
    /**
     * Al arrastrar el ancho de la columna calculamos la posición de inicio y final
     * @param {String} field Nombre de la columna que se está arrastrando para cambiar su ancho
     * @param {Event} event Información del evento drag
     */
    drag(field, event) {
      const { screenX } = event;
      if (screenX !== 0 && this.lastDragXPosition) {
        const delta = screenX - this.lastDragXPosition;
        if (this.widthsData[field] + delta >= 70) {
          const newPos = this.widthsData[field] + delta;
          this.widthsData[field] = newPos;
        }
      }
      this.lastDragXPosition = screenX;
    },
    /**
     * Setteamos a 0 de nuevo la variable que nos ayuda a calcular la posición de la columna
     */
    dragEnd() {
      this.lastDragXPosition = 0;
      this.$emit('widths', this.widthsData);
      localStorage.setItem(`table_width_${this.$route.name}`, JSON.stringify(this.widthsData));
    },

    /**
     * Ordenamos una columna
     * @param {String} field Campo a ordenar
     */
    sort(field) {
      const isNotSortable = this.notSortableFields.includes(field);
      if (isNotSortable) return;

      let targetField = this.orderByFields.find(item => item.field === field);

      if (targetField) {
        // Si el campo ya está en la lista de ordenación
        targetField.order = targetField.order === 'asc' ? 'desc' : 'asc';
      } else {
        // Si el campo no está en la lista de ordenación
        targetField = { field, order: 'asc' };
        this.orderByFields.push(targetField);
      }

      // Filtrar los campos duplicados
      this.orderByFields = this.orderByFields.filter(item => item.field !== field);

      // Actualizar la lista de ordenación
      this.orderByFields.push(targetField);

      if (!this.orderByFields.length) {
        // Si no hay campos por los que ordenar, emitir evento con 'false'
        this.updateQueryParams(null);
      } else {
        // Si hay campos por los que ordenar, actualizar la URL y emitir evento
        const sortsBy = this.orderByFields.map(item => `${item.field} ${item.order}`).join(', ');
        this.updateQueryParams(sortsBy);
      }
    },

    updateQueryParams(sortsBy) {
      const queryParams = sortsBy ? { 'sorts-by': sortsBy } : {};
      const newQueryParams = Object.assign({}, this.$route.query, queryParams);

      this.$router.replace({ path: this.$route.fullPath, query: newQueryParams }).then(() => {
        this.$emit('sort', sortsBy || false);
      });
    },

    /**
     * @override
     */
    selectAll() {
      const status = (this.selectAllItems = !this.selectAllItems);
      this.$emit('selectAll', status);
    },
    /**
     * convert url to orderByFields
     */
    urlToOrderByFields() {
      let sortsArray = [];
      if (this.$route.query['sorts-by'] && this.$route.query['sorts-by'].length) {
        sortsArray = this.$route.query['sorts-by'].split(', ');
      }
      sortsArray.forEach(element => {
        const sort = {
          field: element.split(' ')[0],
          order: element.split(' ')[1]
        };
        this.orderByFields.push(sort);
      });
    }
  },
  computed: {
    /**
     * Devuelve las columnas que tienen el check 'activo' a true
     * @return {Array} Array de columnas visibles
     */
    colsVisible() {
      return this.cols.filter(x => x.active === true);
    },
    /**
     * @override
     */
    totalWidth() {
      let total = 50;
      this.columns.forEach(x => {
        total = total + this.widths[x.field];
      });
      // Se suma el tamaño del slot
      total += 42;
      return `${total}px`;
    }
  },
  watch: {
    widths() {
      this.widthsData = Object.assign({}, this.widths);
    }
  },
  /**
   * @override
   */
  mounted() {
    this.cols = this.columns;
    this.widthsData = Object.assign({}, this.widths);
    this.urlToOrderByFields();
  }
};
